// @flow
export const dataKey: 'purchases_by_funds' = 'purchases_by_funds';
